module.exports = __webpack_public_path__ + "img/q-5-1@2x.3544d5e0.png";